// resources/js/app.js
import { createApp } from 'vue'
import App from './pages/App.vue'
import store from './vuex/app'
import router from './router/app'
import 'chart.js/auto'

// --- Vuetify ---
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css' // icon set
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
  icons: { defaultSet: 'mdi' },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          success: '#2e7d32',
          error: '#d32f2f',
        },
      },
    },
  },
})

// Mount
const app = createApp(App)
app.use(store)
app.use(router)
app.use(vuetify)
app.mount('#app')